import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationConstants } from '@constants/app.constants';
import { MotifButtonModule } from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CommonService } from '@services/common.service';

@Component({
  selector: 'app-logout',
  imports: [TranslatePipe, TranslateDirective, MotifButtonModule],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {
  moduleName: string = '';

  constructor(
    private readonly router: Router,
    private readonly commonService: CommonService,
  ) {
    this.moduleName =
      this.commonService.getActiveModuleFromLocalStorage() ===
      ApplicationConstants.PMPRO
        ? 'PM Pro'
        : 'IPOR';
    const moduleLabel =
      this.moduleName.toLowerCase() === ApplicationConstants.IPOR
        ? 'IPO Ready'
        : 'PM Pro';
    document.title = moduleLabel;
  }

  login() {
    this.router.navigateByUrl('/');
    //if need to sign out of account then use the below line
    // this.appComponent.logout();
  }
}
